const COMMENTS = [
  {
    name: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20avatar%20icon%20with%20a%20smiling%20face%2C%20minimalist%20flat%20design%2C%20orange%20and%20cream%20colors%2C%20friendly%20vibe&width=100&height=100&seq=avatar-comment-01&orientation=squarish',
    text: '这个平台真的太猛了！每天蹲更新比追剧还上头，爆料的真实度比其他平台高太多了。已经推荐给身边所有朋友了！',
    time: '2小时前',
    likes: 128,
    tag: '忠实用户',
  },
  {
    name: '匿名吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20avatar%20icon%20with%20a%20mysterious%20face%2C%20minimalist%20flat%20design%2C%20coral%20and%20beige%20colors%2C%20anonymous%20vibe&width=100&height=100&seq=avatar-comment-02&orientation=squarish',
    text: '作为行业内的人，看到有些爆料说得八九不离十，真的佩服。这个大赛机制也很合理，好内容确实能浮上来。',
    time: '5小时前',
    likes: 96,
    tag: '业内人士',
  },
  {
    name: '爆料小能手',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20avatar%20icon%20with%20an%20enthusiastic%20face%2C%20minimalist%20flat%20design%2C%20amber%20and%20cream%20colors%2C%20energetic%20vibe&width=100&height=100&seq=avatar-comment-03&orientation=squarish',
    text: '上周投的爆料居然进了热榜前三！虽然没拿冠军但看到那么多人讨论自己提供的信息，成就感满满。继续挖掘好料！',
    time: '1天前',
    likes: 203,
    tag: '参赛选手',
  },
  {
    name: '理性吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20avatar%20icon%20with%20a%20thoughtful%20face%2C%20minimalist%20flat%20design%2C%20terracotta%20and%20cream%20colors%2C%20calm%20vibe&width=100&height=100&seq=avatar-comment-04&orientation=squarish',
    text: '每天上班摸鱼就靠这个续命了。建议增加一个「已实锤」标签功能，这样我们可以快速筛选已经被证实的爆料。',
    time: '2天前',
    likes: 67,
    tag: '活跃用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">吃瓜热评</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          看看吃瓜群众们都在聊什么
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
          {COMMENTS.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800">{comment.name}</span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-accent-100 text-accent-600 font-medium whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
              <div className="flex items-center gap-4 mt-4 text-xs text-foreground-400">
                <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line text-sm"></i>
                  {comment.likes}
                </button>
                <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line text-sm"></i>
                  回复
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}